import React, { useState } from "react";
import {
  Typography,
  IconButton,
  Popover,
  FormControlLabel,
  Checkbox,
  Button,
  Box,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";

const OptionSelector = ({ selectedstakeholders, setSelectedstakeholders }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState(selectedstakeholders);

  const options = [
    "Investor",
    "Employee",
    "Business partner",
    "NGO",
    "Customer",
    "Community Member",
  ];

  const handleToggle = (option) => {
    setSelectedOptions((prev) =>
      prev.includes(option)
        ? prev.filter((opt) => opt !== option)
        : [...prev, option]
    );
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const anchorId = open ? "options-popover" : undefined;

  return (
    <Box display="flex" alignItems="center">
      <IconButton onClick={handleClick} size="small">
        <SettingsIcon />
      </IconButton>

      <Popover
        id={anchorId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2}>
          {options.map((option) => (
            <FormControlLabel
              key={option}
              control={
                <Checkbox
                  checked={selectedOptions.includes(option)}
                  onChange={() => handleToggle(option)}
                  sx={{
                    color: "#8C2148",
                    "&.Mui-checked": {
                      color: "#8C2148",
                    },
                  }}
                />
              }
              label={option}
            />
          ))}

          <Box mt={2} textAlign="center">
            <Button
              variant="contained"
              disabled={selectedOptions.length !== 3}
              onClick={() => {
                console.log("Confirmed with:", selectedOptions);
                setSelectedstakeholders(selectedOptions);
                handleClose();
              }}
              sx={{
                backgroundColor: "#8C2148",
                "&:hover": {
                  backgroundColor: "#721938",
                },
              }}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export default OptionSelector;
